var map = {
	"./ak-gida-logo.png": 322,
	"./aksigorta-logo.png": 2867,
	"./allianz-logo.png": 7048,
	"./anadolu-efes-logo.png": 1107,
	"./anadolu-hayat-emeklilik-logo.png": 5162,
	"./anadolu-isuzu-logo.png": 9024,
	"./arcelik-logo.png": 1227,
	"./avon-logo.png": 8762,
	"./bat-logo.png": 1944,
	"./beiersdorf-logo.png": 3053,
	"./borusan-logo.png": 2466,
	"./bosch-logo.png": 5406,
	"./bsh-logo.png": 4758,
	"./cci-logo.png": 1676,
	"./coca-cola-logo.png": 4936,
	"./colgate-logo.png": 3258,
	"./danone-logo.png": 249,
	"./deloitte-logo.png": 5798,
	"./denizbank-logo.png": 4714,
	"./dogus-logo.png": 7551,
	"./eczacıbaşı-logo.png": 9223,
	"./eti-logo.png": 6896,
	"./ey-logo.png": 9618,
	"./ford-otosan-logo.png": 7421,
	"./golf-logo.png": 4026,
	"./hayat-logo.png": 8726,
	"./hepsiburada-logo.png": 568,
	"./ing-logo.png": 8549,
	"./istegelsin-logo.png": 4509,
	"./jti-logo.png": 4342,
	"./kordsa-logo.png": 9879,
	"./kpmg-logo.png": 1470,
	"./lcw-logo.png": 3222,
	"./loreal-logo.png": 1989,
	"./marsh-logo.png": 5825,
	"./mckinsey-company-logo.png": 8937,
	"./mercedes-benz-logo.png": 1621,
	"./migros-logo.png": 2793,
	"./mondelez-logo.png": 9261,
	"./nestle-logo.png": 1363,
	"./odas-logo.png": 4963,
	"./oyak-renault-logo.png": 5926,
	"./p&g-logo.png": 9808,
	"./pepsico-logo.png": 5781,
	"./perfetti-logo.png": 3498,
	"./pernod-ricard-logo.png": 7998,
	"./pfizer-logo.png": 9740,
	"./pladis-logo.png": 2885,
	"./pmi-logo.png": 5746,
	"./pwc-logo.png": 2069,
	"./qnb-logo.png": 112,
	"./reckitt-logo.png": 1180,
	"./sahibinden-logo.png": 3075,
	"./samsung-logo.png": 1283,
	"./schneider-logo.png": 705,
	"./sisecam-logo.png": 50,
	"./sistem-global-logo.png": 4040,
	"./tei-logo.png": 5481,
	"./tf-logo.png": 1115,
	"./tide-logo.png": 8623,
	"./tofas-logo.png": 1228,
	"./turcell-logo.png": 7894,
	"./turk-telekom-logo.png": 398,
	"./turkish-aerospace-logo.png": 6981,
	"./turkiye-is-bankasi-logo.png": 544,
	"./unilever-logo.png": 702,
	"./vestel-logo.png": 1434,
	"./vodafone-logo.png": 519,
	"./yandex-logo.png": 1489,
	"./yapikredi-logo.png": 6001,
	"./yildiz-holding-logo.png": 5764,
	"./áimsa-logo.png": 9742
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4489;